const HelpingHand = () => (
  <svg
    aria-hidden="true"
    className="e-font-icon-svg e-fas-hands-helping"
    width="50"
    height="50"
    fill="white"
    viewBox="0 0 640 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"></path>
  </svg>
);
const HandDollar = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-fas-hand-holding-usd"
    viewBox="0 0 576 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"></path>
  </svg>
);
const HandMedical = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-fas-hand-holding-medical"
    viewBox="0 0 576 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"></path>
  </svg>
);
const Calendar = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-far-calendar-alt"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path>
  </svg>
);
const SquareCheck = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-far-check-square"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"></path>
  </svg>
);
const HandShake = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-far-handshake"
    viewBox="0 0 640 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"></path>
  </svg>
);
const ClinicMedical = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-fas-clinic-medical"
    viewBox="0 0 576 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"></path>
  </svg>
);
const CalendarCheck = () => (
  <svg
    aria-hidden="true"
    width="50"
    height="50"
    fill="white"
    className="e-font-icon-svg e-fas-calendar-check"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"></path>
  </svg>
);
export const PERKS_AND_BENEFITS = [
  {
    icon: <HandDollar />,
    title: "Competitive Salary",
    content: "Unlock Your Potential with Competitive Salary: Where Value Meets Reward.",
  },
  {
    icon: <HelpingHand />,
    title: "Facility Credentialing Support",
    content: "Empowering Excellence: Your Partner in Facility Credentialing Success.",
  },
  {
    icon: <HandMedical />,
    title: "Medical, Dental & Vision Insurance",
    content: "Clear Vision, Bright Smiles, and Healthy Lives: Our Commitment to Your Well-Being.",
  },
  {
    icon: <Calendar />,
    title: "Paid Vacation Time",
    content: "Relax, Recharge, and Rejuvenate: Your Time Off, Our Priority.",
  },
  {
    icon: <CalendarCheck />,
    title: "Paid Sick Leave",
    content: "Stay Healthy, Stay Supported: Your Wellness Matters, Even on Sick Days.",
  },
  {
    icon: <SquareCheck />,
    title: "Paid National Holidays",
    content: "Time to Celebrate: Honoring Tradition, Supporting You Every Day.",
  },
  {
    icon: <HandShake />,
    title: "401(k) Retirement plan with company matching",
    content: "Building Your Future Together: Investing in Your Retirement Goals.",
  },
  {
    icon: <ClinicMedical />,
    title: "Continuing Medical Education support",
    content: "Investing in Your Professional Development.",
  },
  {
    icon: <Calendar />,
    title: "Hands-On Training",
    content: "Interactive Learning for Skill Mastery.",
  },
  {
    icon: <SquareCheck />,
    title: "Career development",
    content: "Career development opportunities with our fast-growing organization",
  },
  {
    icon: <CalendarCheck />,
    title: "Surgical Scheduling",
    content: "Precision in Scheduling, Seamless Operations.",
  },
  {
    icon: <HandShake />,
    title: "Administrative Billing Support",
    content: "Streamlined Billing Solutions, Administrative Ease.",
  },
  {
    icon: <Calendar />,
    title: "Payroll processing",
    content: "Payroll processing with optional direct deposit",
  },
];

// ===CAREERS_DATA===
export const CAREERS_DATA = {
  Surgical_Assitant: {
    title: "Why Join Universal Surgical Assistants?",
    image: "/images/careers/surgical-assistant.webp",
    data: [
      {
        item: "Comprehensive training aligned with your specialty of interest and dedication to patient care",
      },
      {
        item: "Full coverage of professional requirements, including licensing, facility credentialing, immunizations, liability insurance, and continuing medical education (CMEs)",
      },
      {
        item: "Structured career advancement opportunities within the innovative and evolving field of robotic surgery",
      },
      {
        item: "Strong commitment to your long-term success with robust support and excellent benefits",
      },
    ],
  },
  Reason_To_Work: {
    title: "Why Work with Universal Surgical Assistants",
    image: "/images/careers/reason-to-work.webp",

    data: [
      {
        item: "Enjoy flexible, predictable schedules that support work-life balance",
      },
      {
        item: "Advance your career with paid training and continuing medical education",
      },
      {
        item: "Take paid vacations while you enjoy full medical coverage to ensure continuum of care",
      },
      {
        item: "Receive full credentialing support for your practicing facilities",
      },
      {
        item: "Benefit from CoreMax Cloud, a cutting-edge technology for scheduling and management support",
      },
      {
        item: "Get prompt support during onboarding with real-time responses to inquiries, and timely certification reminders",
      },
    ],
  },
  Care_Philosophy: {
    title: "REASONS TO WORK WITH UNIVERSAL SURGICAL",
    // contentTop: "We uphold the ethics of “Total Care Philosophy” which defines pathways to engage with Surgeons for an optimal patient outcome.",
    // contentBot:
    //   "We are committed to train passionate Surgical and Physician Assistants to expand our team for a remarkable journey throughout their career.  Our providers enjoy the freedom to focus on patient care while achieving the highest level of patient outcome.",
    image: "/images/careers/CarePhilosophy.webp",
    image2: "/images/careers/CarePhilosophy2.png",
    data: [
      {
        item: "Earn a better and steady salary with on-call compensation and no unexpected or forced time off",
      },
      {
        item: "Take paid vacations, with full backup coverage",
      },
      {
        item: "Get credentialled by us wherever you need to work",
      },
      {
        item: "Work for a well-respected, employee-friendly company with more than 30 years in business",
      },
      {
        item: "Access to new innovative software, CoreMax Surgical for scheduling and billing support services",
      },
      {
        item: "Enjoy full transparency in a company that truly values and respects its employees",
      },
      {
        item: "Get real-time responses to your questions, help with onboarding, timely certification reminders",
      },
    ],
  },
};

export const SpecialTeam = [
  {
    title: "Obstetrics & Gynecology SURGERY",
    title1: "POSITION:",
    title2: "SURGICAL ASSISTANT",
    content:
      "Obstetrics & Gynecology trained Surgical specialists utilize help from our Assistants in extensive Surgical procedures to comply with advancements in the field.",
    icon: "/images/special-team/6.png",
  },
  {
    title: "ORTHOPEDIC SURGERY",
    title1: "POSITION:",
    title2: "SURGICAL ASSISTANT",
    content:
      "Orthopedic Surgical specialists provide minimally invasive to complex surgeries in collaboration with our expert Surgical and Physician Assistants. ",
    icon: "/images/special-team/3.png",
  },
  {
    title: "NEUROSPINAL SURGERY",
    title1: "POSITION:",
    title2: "SURGICAL ASSISTANT",
    content:
      "Spinal & Neurosurgical specialists improve care, outcomes, and recovery with our skilled team to drive maximum progress in continuum of care.",
    icon: "/images/special-team/5.png",
  },
  {
    title: "ROBOT SURGERY",
    title1: "POSITION:",
    title2: "SURGICAL ASSISTANT",
    content:
      "Robotic Surgical specialists utilize advanced AI precision in coordination with our trained Surgical & Physician Assistants to boost patient excellence recovery process.",
    icon: "/images/special-team/4.png",
  },
  {
    title: "CARDIOTHORACIC SURGERY",
    title1: "POSITION:",
    title2: "SURGICAL ASSISTANT",
    content:
      "Universal Surgical Assistants provides expert cardiac care, performing  over 20,000 successful surgeries with cutting-edge technology & expertise.",
    icon: "/images/special-team/1.png",
  },
  {
    title: "GENERAL SURGERY",
    title1: "POSITION:",
    title2: "SURGICAL ASSISTANT",
    content:
      "General surgical specialists performing various procedures in day to day collaboration with our skilled, multispecialty-trained care team providers.",
    icon: "/images/special-team/2.png",
  },
];
